export const formInProgress = 'ROLE/formInProgress';
export const receiveSystemRoles = 'ROLE/receiveSystemRoles';
export const receiveCustomRoles = 'ROLE/receiveCustomRoles';
export const receiveRole = 'ROLE/receiveRole';
export const requestData = 'ROLE/requestData';
